import {
  fetchMenuError,
  fetchMenuSuccess,
  fetchtMenuRequest,
  fetchDMfail,
  fetchDMrequest,
  fetchDMsuccess,

  fetchQLfail,
  fetchQLrequest,
  fetchQLsuccess,

  fetchALfail,
  fetchALrequest,
  fetchALsuccess,
} from '../store/ActionReducers/menu.actionreducer';
import { Dispatch } from 'redux';
import { httpbase } from '../utils/axios.utils';
import { lang } from '../config/app.config';


export const loadMenu = (slug: string) => {
  return async (dispatch: Dispatch) => {
    dispatch(fetchtMenuRequest());
    try {
      const response = await httpbase().get(`resources/menus/${slug}?lang=${lang}`);
      dispatch(fetchMenuSuccess(response.data.data));
    } catch (e: any) {
      if (e && e.response && e.response.data) {
        dispatch(fetchMenuError(e.response.data));
      }
      dispatch(fetchMenuError("Something went wrong!"));
    }
  }
}

// district menu
export const loadDM = (slug: string) => {
  return async (dispatch: Dispatch) => {
    dispatch(fetchDMrequest());
    try {
      const response = await httpbase().get(`resources/menus/${slug}?lang=${lang}`);
      dispatch(fetchDMsuccess(response.data.data));
    } catch (e: any) {
      if (e && e.response && e.response.data) {
        dispatch(fetchDMfail(e.response.data));
      }
      dispatch(fetchDMfail("Something went wrong!"));
    }
  }
}


// quick links
export const loadQL = (slug: string) => {
  return async (dispatch: Dispatch) => {
    dispatch(fetchQLrequest());
    try {
      const response = await httpbase().get(`resources/menus/${slug}?lang=${lang}`);
      dispatch(fetchQLsuccess(response.data.data));
    } catch (e: any) {
      if (e && e.response && e.response.data) {
        dispatch(fetchQLfail(e.response.data));
      }
      dispatch(fetchQLfail("Something went wrong!"));
    }
  }
}


// aditional links
export const loadAL = (slug: string) => {
  return async (dispatch: Dispatch) => {
    dispatch(fetchALrequest());
    try {
      const response = await httpbase().get(`resources/menus/${slug}?lang=${lang}`);
      dispatch(fetchALsuccess(response.data.data));
    } catch (e: any) {
      if (e && e.response && e.response.data) {
        dispatch(fetchALfail(e.response.data));
      }
      dispatch(fetchALfail("Something went wrong!"));
    }
  }
}

